<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <!-- <div class="swiper-slide">
        <img src="@/assets/images/banner1.png" alt="" />
      </div>
      <div class="swiper-slide">
        <img src="@/assets/images/banner2.png" alt="" />
      </div> -->
      <div
        class="swiper-slide"
        v-for="(item, index) in bannerList"
        :key="index"
      >
        <img :src="item" alt="" />
      </div>
    </div>
    <!-- 如果需要分页器 -->
    <!-- <div class="swiper-pagination"></div> -->

    <!-- 如果需要导航按钮 -->
    <!-- <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div> -->

    <!-- 如果需要滚动条 -->
    <!-- <div class="swiper-scrollbar"></div> -->
  </div>
</template>
<script>
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
export default {
  name: "HelloWorld",
  data() {
    return {
      bannerList: [],
    };
  },
  mounted() {
    this.bannerList = this.$store.state.mystate.bannerList;
    setTimeout(() => {
      new Swiper(".swiper-container", {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        modules: [Autoplay],
      });
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.swiper-container {
  margin: 0 22px;
  // width: 330px;
  // height: 160px;
  border-radius: 12px;
  overflow: hidden;
  .swiper-wrapper {
    width: 100%;
    .swiper-slide {
      max-height: 212px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue